import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private readonly auth: AuthService,
        private readonly router: Router,
    ) {}

    canActivate(): boolean {
        // If the user is not logged in we'll send them back to the home page
        if (!this.auth.authenticatedValidUser) {
            void this.router.navigate(['login']);
            return false;
        }
        return true;
    }
}
